import isObject from 'lodash/isObject';
import { filterExistingProperties } from './utils/functions';
class DebugConsole {
  brain: any;
  debugConsole?: HTMLElement;
  debugMessages?: HTMLUListElement;
  constructor(brain: any) {
    this.brain = brain;
  }
  initDebugConsole() {
    console.log('------------------------------');
    console.log('Press Ctrl + D to open the debug console');
    const elements = this.#createDebugConsole();
    this.debugConsole = elements.consoleDiv;
    this.debugMessages = elements.messageList;

    document.addEventListener('keydown', function (event) {
      if (event.ctrlKey && event.key === 'd') {
        event.preventDefault();
        window.rxcBrain.debugConsole?.toggleDebugConsole();
      }
    });
  }
  #createDebugConsole() {
    const consoleDiv = document.createElement('div');
    consoleDiv.id = 'debugConsole';
    consoleDiv.style.display = 'none';

    const consoleTitle = document.createElement('h3');
    consoleTitle.textContent = 'Debug Console';

    const messageList = document.createElement('ul');
    messageList.id = 'debugMessages';

    consoleDiv.appendChild(consoleTitle);
    //consoleDiv.appendChild(clearButton);
    consoleDiv.appendChild(messageList);

    document.body.appendChild(consoleDiv);

    return {
      consoleDiv: consoleDiv,
      messageList: messageList,
    };
  }
  toggleDebugConsole() {
    const debugConsole = document.getElementById('debugConsole');
    if (!debugConsole) return;
    if (debugConsole.style.display === 'none') {
      debugConsole.style.display = 'block';
    } else {
      debugConsole.style.display = 'none';
    }
  }

  logMessage(message: HTMLElement) {
    const newMessage = document.createElement('li');
    newMessage.append(message);
    this.debugMessages?.appendChild(newMessage);
    if (this.debugConsole) {
      this.debugConsole.scrollTop = this.debugConsole?.scrollHeight;
    }
  }
  #getSearchParams() {
    // example:
    // http://localhost:3000/?type=SingleVision&antiReflective=Standard&color=Amethyst
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of searchParams) {
      params[key] = value;
    }
    return params;
  }
  logFilteredPackagesFromURL() {
    const params = this.#getSearchParams();
    const filteredPackages = this.brain?.currentPackages
      ?.filter((s) => filterExistingProperties(s.lensPackage, params))
      .map((pkg) => pkg.lensPackage);

    console.log('------------------------------');
    console.log('filtered packages: ', filteredPackages);

    const exportCsvButton = document.createElement('button');
    exportCsvButton.textContent = 'Export CSV';
    exportCsvButton.onclick = () => this.#handleExportCSV(filteredPackages);

    const message = document.createElement('pre');
    message.textContent = '- filtered packages: ';
    message.appendChild(exportCsvButton);
    this.logMessage(message);
  }
  logFilteredPackages() {
    console.log('------------------------------');
    console.log('filtered packages: ', this.brain?.currentPackages);

    const exportCsvButton = document.createElement('button');
    exportCsvButton.textContent = 'Export CSV';
    exportCsvButton.onclick = () =>
      this.#handleExportCSV(
        this.brain?.currentPackages?.map((pkg) => pkg.lensPackage)
      );

    const message = document.createElement('pre');
    const divider = document.createElement('div');
    message.textContent = `- filtered packages: ${this.brain?.currentPackages?.length} `;
    divider.textContent =
      '----------------------------------------------------------------';
    message.appendChild(exportCsvButton);
    this.logMessage(message);
    this.logMessage(divider);
  }
  logCurrentStep() {
    console.log('------------------------------');
    console.log('current step: ', this.brain?.currentStep);

    const message = document.createElement('pre');
    message.textContent = `- current step: ${this.brain?.currentStep?.key}`;
    this.logMessage(message);
  }

  #handleExportCSV(data?: any) {
    const convertToCSV = (data?: Lens[]) => {
      const header = Object.keys(data[0]).join(',') + '\n';
      const body = data.map((obj) => Object.values(obj).join(',')).join('\n');
      return header + body;
    };

    const formattedData = (data?: any) => {
      const _data = data.map((pkg) => {
        let _pkg = pkg;
        if (_pkg.promo) {
          _pkg = { ..._pkg, promo: Object.keys(_pkg.promo)[0] };
        }
        if (_pkg.rxValues) {
          let _rxValues = {};
          Object.entries(_pkg.rxValues).forEach(([key, val]) => {
            if (isObject(val)) {
              return Object.entries(val).forEach(([key2, val2]) => {
                _rxValues[key + '_' + key2] = val2;
              });
            } else {
              _rxValues[key] = val;
            }
          });
          _pkg = { ..._pkg, ..._rxValues };
          delete _pkg.rxValues;
        }

        return _pkg;
      });
      return _data;
    };

    const csv = convertToCSV(formattedData(data));
    const csvData = new Blob([csv], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvData);

    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'packages.csv';
    link.click();

    URL.revokeObjectURL(csvUrl);
  }
}

export default DebugConsole;
